import(/* webpackMode: "eager" */ "/opt/trendrain/trendrain-web/src/app/guide/page.tsx");
